import { ManagerSubscriptionAccount, SubscriptionStatus, UserSubscriptionPlan, type UserData } from "../constants/GlobalTypesAndEnumsAndConstants";
import { hasActivePaidEntitlement } from "./subscription-entitlements";

type BillingFields = Pick<NonNullable<UserData["subscription_information"]>,
  "subscription_id" | "manager_subscription_account">;

/** Billing ownership is independent of a paid plan or a creator grant. */
export function getSubscriptionBillingIdentity(subscription?: Partial<BillingFields> | null) {
  const hasSubscriptionBinding = typeof subscription?.subscription_id === "string" &&
    subscription.subscription_id.trim().length > 0;
  const managerSubscriptionAccount = hasSubscriptionBinding
    ? subscription?.manager_subscription_account ?? ManagerSubscriptionAccount.Stripe
    : undefined;
  const hasRecognizedBillingBinding = hasSubscriptionBinding &&
    (managerSubscriptionAccount === ManagerSubscriptionAccount.Stripe ||
      managerSubscriptionAccount === ManagerSubscriptionAccount.Apple ||
      managerSubscriptionAccount === ManagerSubscriptionAccount.Google);
  return { hasSubscriptionBinding, managerSubscriptionAccount, hasRecognizedBillingBinding };
}

/** A pause changes collection on an existing paid Stripe subscription. */
export function canPauseStripeSubscription(user: UserData | null | undefined) {
  const subscription = user?.subscription_information;
  const billing = getSubscriptionBillingIdentity(subscription);
  const hasCreatorAccessWithoutPaidBilling = subscription?.subscription_plan_type === UserSubscriptionPlan.ELITE &&
    subscription?.creator_comped_elite === true && subscription?.creator_comped_paid_subscription_active !== true;
  return Boolean(user?.id && billing.hasRecognizedBillingBinding &&
    billing.managerSubscriptionAccount === ManagerSubscriptionAccount.Stripe &&
    subscription?.subscription_status === SubscriptionStatus.ACTIVE &&
    !subscription.subscription_resume_pending_payment && !subscription.subscription_pause_requested &&
    !subscription.will_subscription_get_canceled_at_period_end && !hasCreatorAccessWithoutPaidBilling &&
    hasActivePaidEntitlement(subscription.subscription_status, subscription.subscription_plan_type, { subscription }));
}
